import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeSentry, Sentry } from "./lib/sentry";
import { SentryFallback } from "./components/SentryFallback";

initializeSentry();

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={({ error, componentStack, resetError }) => (
      <SentryFallback error={error} componentStack={componentStack} resetError={resetError} />
    )}
  >
    <App />
  </Sentry.ErrorBoundary>
);
